<template>
  <div
    class="height100vh flex flex-col"
    @click="
      navList[1].isShowDropDown = false;
      shouUserMore = false;
    "
  >
    <div
      class="header-box"
      v-show="$store.state.region!='5'"
    >
      {{$store.state.region | roleFilterText }}
      2022年职业院校技能大赛——教学能力大赛   
    </div>
     <!-- <div
      class="header-box"
      v-show="$store.state.region=='5'"
    >
      金石榴网络育人创新联盟平台
    </div> -->
    <div
      class="header-box"
      v-show="$store.state.region=='5'"
    >
    </div>
    <div class="bg-red">
      <div class="flex nav-box">
        <div class="flex-1">
          <navbar
            :navList="navList"
            @jumpPage="jumpPage"
            @isShowDropDown="navList[1].isShowDropDown = true"
          ></navbar>
        </div>
        <div
          class="flex align-items-center user-box"
          @click.stop
          @click="shouUserMore = !shouUserMore"
        >
          <a-avatar
            style="width: 30px; height: 30px; margin-right: 15px"
            icon="user"
          />
          <div class="flex align-items-center">
            <div
              style="max-width: 120px; min-width: 50px"
              class="nowrap"
              :title="$store.state.user.realname"
            >
              {{ $store.state.user.realname }}
            </div>
            <img class="img-small" src="@/assets/images/img41.png" alt="" />
          </div>
          <div class="user-more" @click.stop v-if="shouUserMore">
            <div
              class="user-more-item"
              @click="
                shouChangepw = true;
                shouUserMore = false;
              "
            >
              修改密码
            </div>
            <div style="border-top: 1px solid #ccc"></div>
            <div class="user-more-item" @click="logout">退出登录</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-box flex-1">
      <!-- <div
        class="bg-box-back"
        :style="`background : url(${backgroundContentImg});background-repeat: no-repeat;
    background-size: 100% 100%;`"
      ></div> -->
      <div class="content-box flex flex-col">
        <div class="breadcrumb-box">
          <!--面包屑导航-->
          <a-breadcrumb separator=">">
            <a-breadcrumb-item
              v-for="breadcrumbItem in breadcrumbList"
              :href="breadcrumbItem.path"
              :key="breadcrumbItem.path"
              @click.native="go(breadcrumbItem)"
              >{{ breadcrumbItem.meta.title }}</a-breadcrumb-item
            >
          </a-breadcrumb>
        </div>
        <div class="container" >
          <a-affix
            :offset-top="300"
            :style="{ position: 'absolute', right: 0 }"
            v-if="this.$store.state.region!=5"
          >
            <div class="a-tip flex flex-col flex-between">
              <router-link class="link" :to="{path:'/personalCenter/guide'}">申报指南</router-link> 
              <router-link class="link" :to="{path:'/personalCenter/downLoad'}">文件下载</router-link>
            </div>
          </a-affix>
          <router-view></router-view>
        </div>
      </div>
    </div>
    <div>
      <foot :FootType="2"></foot>
    </div>
    <div v-if="shouChangepw">
      <a-modal
        v-model="shouChangepw"
        :title="firstLoginReset ? '首次登录重置密码' : '修改密码'"
        :width="420"
      >
        <p
          style="
            margin-top: 15px;
            color: #9a0b00;
            background: #fdf1ef;
            border-radius: 4px;
            padding: 6px 10px;
          "
          v-if="firstLoginReset"
        >
          检测到您是首次登录，为保障账号安全，请先重置初始密码后再使用系统。
        </p>
        <p style="margin-top: 15px">原密码</p>
        <a-input
          type="password"
          placeholder="请输入原密码"
          v-model="passwordEdit.oldpassword"
        />
        <p style="margin-top: 15px">新密码</p>
        <a-input
          placeholder="请输入新密码"
          type="password"
          v-model="passwordEdit.password"
        />
        <p style="margin-top: 15px">确认密码</p>
        <a-input
          type="password"
          placeholder="请输入确认密码"
          v-model="passwordEdit.confirmpassword"
        />
        <template slot="footer">
          <a-button @click="cancelChangepw">取消</a-button>
          <a-button
            style="background: #9a0b00; color: #fff"
            @click="handleOkChangepw"
            >{{ firstLoginReset ? "确认重置" : "确认" }}</a-button
          >
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { LogOut, updatePassword } from "@/api/index";
import navbar from "@/components/navbar";
import foot from "@/components/footer";

// 首次登录改密提示标记：登录成功时由 login.vue 清除，这里弹出后置位，
// 用于「刷新页面不再重复弹，重新登录才重新判断」
const FIRST_LOGIN_PWD_PROMPTED_KEY = "firstLoginPwdPrompted";

export default {
  name: "",
  components: {
    navbar,
    foot,
  },
  props: {},
  data() {
    return {
      passwordEdit: {
        username: "",
        oldpassword: "",
        password: "",
        confirmpassword: "",
      },
      // backgroundImg: require("@/assets/images/img20.jpg"),
      // // backgroundImglf: require("../../assets/images/img61.png"),
      // backgroundImgcz: require("@/assets/images/img20-1.jpg"),
      // backgroundContentImg: require("@/assets/images/img35.png"),
      navList: [
        { name: "首页", routeName: "Index" },
        // { name: "大赛报名", routeName: "competitionEnroll" },
        // {
        //   name: "教学能力大赛",
        //   routeName: "szStudio",
        // },
        {
          name: "网络育人创新联盟",
          routeName: "alApply",
        },
        // {
        //   name: "抽签",
        //   routeName: "lottery",
        // },
        {
          name: "抽签结果公示",
          routeName: "lotteryResult",
        },
        // {
        //   name: "典型小案例申报",
        //   routeName: "xal",
        // },
        // {
        //   name: "名班主任工作室建设组",
        //   routeName: "educationalBrand",
        // },
        // {
        //   name: "思政微课",
        //   routeName: "szMicroClass",
        // },
        // {
        //   name: "通知公告",
        //   routeName: "Notice",
        // },
      ],
      shouUserMore: false,
      shouChangepw: false,
      // 首次登录（school-role，userInfo.firstLogin===1）需强制重置密码
      firstLoginReset: false,
    };
  },
  computed: {
    breadcrumbList() {
      return this.$route.matched;
    },
  },
  watch: {},
  created() {
	// if(this.$store.state.region='5'){
	// 			this.navList.splice(1,1,{
  //         name: "网络育人创新联盟",
  //         routeName: "alApply",
  //      });
	// }
  },
  mounted() {
    const role = this.$store.state.role;
    // 首次登录（school-role 且 userInfo.firstLogin===1）：自动弹出重置密码
    this.checkFirstLogin();
    // 按角色过滤菜单：visibleRoles 传数组表示多个角色均可见
    // 「抽签结果公示」school-role（分社）与 education-role（教育局）都可见，
    // 其中 school-role 在页面内会额外带 branchId=登录人 id，只看本分社数据
    const removeByRole = (routeName, visibleRoles) => {
      const roles = Array.isArray(visibleRoles) ? visibleRoles : [visibleRoles];
      if (roles.indexOf(role) > -1) return;
      const idx = this.navList.findIndex((i) => i.routeName === routeName);
      if (idx > -1) this.navList.splice(idx, 1);
    };
    // removeByRole("lottery", "school-role");
    removeByRole("lotteryResult", ["school-role", "education-role"]);

    // 报名表上传：仅 school-role（分社管理角色）可见；北京时间超过 2026-09-14 18:00:00 后隐藏
    if (role === "school-role") {
      // 截止时刻：2026-09-14 18:00:00（北京时间，UTC+8 → 即 UTC 2026-09-14 10:00:00）
      const deadlineMs = Date.UTC(2026, 8, 14, 10, 0, 0);
      if (Date.now() <= deadlineMs) {
        this.navList.push({
          name: "报名表上传",
          routeName: "registrationForm",
        });
      }
    }

    // 报名表管理：仅 education-role（教育局角色）可见
    if (role === "education-role") {
      this.navList.push({
        name: "报名表管理",
        routeName: "registrationManage",
      });
    }

    // 抽签：仅 draw-role（学校管理角色）可见（该角色登录后默认进入抽奖页）
    if (role === "draw-role") {
      this.navList.push({
        name: "抽签",
        routeName: "lottery",
      });
    }

    if (role === "education-role") {
      let jyjitem = {
        name: "系统设置",
        dropDownList: [
          {
            title: "用户管理",
            routeName: "systemSettingsUserManagement",
          },
          {
            title: "申报设置",
            routeName: "systemSettingsSetUp",
          },
          {
            title: "评审设置",
            routeName: "systemSettingsReviewSetUp",
          },
          // {
          //   title: "结果公布",
          //   routeName: "systemSettingsResult",
          // },
        ],
        isShowDropDown: false,
        routeName: "systemSettings",
        type: "dropDown",
      };
      this.navList.splice(1, 0, jyjitem);
    }else if(role === "expert-role" || role === "view-role" || role === "admin"){
       this.navList.splice(1, 1);
    }
  },
  methods: {
    jumpPage(item) {
      this.$router.push({
        name: item.routeName,
      });
      sessionStorage.removeItem('qbsj');
    },
    // 首次登录检测：school-role 且 sys/login 返回 userInfo.firstLogin===1 → 弹重置密码
    // 只在「本次登录」内弹一次：弹过就置标记，刷新页面不再重复弹；
    // 重新登录时 login.vue 会清掉该标记，届时再按后端 firstLogin 重新判断
    checkFirstLogin() {
      const role = this.$store.state.role;
      const user = this.$store.state.user || {};
      if (role !== "school-role" || Number(user.firstLogin) !== 1) return;
      // 本次登录已提示过（无论是否修改密码），刷新不再弹
      if (
        window.sessionStorage.getItem(FIRST_LOGIN_PWD_PROMPTED_KEY) === "1"
      ) {
        return;
      }
      window.sessionStorage.setItem(FIRST_LOGIN_PWD_PROMPTED_KEY, "1");
      this.firstLoginReset = true;
      this.shouChangepw = true;
    },
    cancelChangepw() {
      this.shouChangepw = false;
      this.passwordEdit.oldpassword = "";
      this.passwordEdit.password = "";
      this.passwordEdit.confirmpassword = "";
    },
    handleOkChangepw() {
      if (!this.passwordEdit.oldpassword) {
        this.$message.warning("请输入原密码");
        return;
      }
      if (!this.passwordEdit.password) {
        this.$message.warning("请输入新密码");
        return;
      }
      if (this.passwordEdit.password !== this.passwordEdit.confirmpassword) {
        this.$message.warning("两次输入的新密码不一致");
        return;
      }
      this.passwordEdit.username = this.$store.state.user.username;
      updatePassword(this.passwordEdit).then((res) => {
        if (res.code === 200) {
          // 首次登录重置成功后：本地同步 firstLogin=0，避免刷新页面再次弹出
          if (this.firstLoginReset) {
            const u = Object.assign({}, this.$store.state.user, {
              firstLogin: 0,
            });
            window.sessionStorage.setItem("userInfo", JSON.stringify(u));
            this.$store.commit("updateUser", u);
            this.firstLoginReset = false;
          }
          this.cancelChangepw();
          this.$message.success(res.message || "密码修改成功");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    logout() {
      LogOut().then((res) => {
        if (res.code === 200) {
          window.sessionStorage.clear();
          this.$store.state.token = null;
          this.$router.push("/home");
        }
      });
    },
    go(path) {
      if (path.meta.title == "首页") {
        this.$router.push({
          name: "Index",
        });
        sessionStorage.removeItem('qbsj');
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/style/mixin.scss';
// .line {
//   height: 0.5px;
// }
.header-box {
  // width: auto;
  height: 172px;
  // position: relative;
  // top: -2px;
  text-align: center;
  font-size: 47px;
  color: #fff;
  line-height:172px;
  text-shadow: 2px 3px rgba(0,0,0,0.5);
  @include themeify{
    background:themed(header-bg);
    background-size: 100% 100%;
  }
}

.bg-red {
  // position: relative;
  // top: -4px;
  background: #db4d30;
//  background: #343fdb;
// background: #9A0B00;
}

.nav-box {
  width: 1350px;
  margin: 0 auto;
  // background: #004fd7;
  // height: 46px;
}

.breadcrumb-box {
  margin-top: 10px;
  padding-left: 25px;
}
.user-more {
  position: absolute;
  width: 100%;
  min-width: 120px;
  top: 46px;
  padding: 0 30px;
  left: 0;
  z-index: 99;
  background: #fff;
  border: 1px solid #ffffff;
  box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.18);
}
.user-more-item:hover {
  color: #9A0B00;
}
.user-box {
  position: relative;
  cursor: pointer;
}
.user-more-item {
  margin: 12px 0;
  text-align: center;
  color: #000;
}
.bg-box {
  // position: relative;
  // background-color: #f8f9ff;
  // background-attachment: fixed;
  @include themeify{
    background:themed(content-bg) no-repeat bottom center,#f8f9ff;
    background-size: 100% auto;
  } 
}
// .bg-box.dt{
//   background: url(~@/assets/images/bg.jpg) no-repeat bottom center, #f8f9ff;
//   background-size: 100% auto;
// }
// .bg-box.cz{
//   background: url(~@/assets/images/bg-1.jpg) no-repeat bottom center, #f8f9ff;
//   background-size: 100% auto;
// }
// .bg-box.ll{
//   background: url(~@/assets/images/bg-ll.jpg) no-repeat bottom center, #f8f9ff;
//   background-size: 100% auto
// }
// .bg-box-back {
//   // background: url(~@/assets/images/img35.png) no-repeat;
//   // background-size: 100% 100%;
//   position: absolute;
//   height: 50%;
//   width: 100%;
//   bottom: 0;
// }
.content-box {
  width: 1350px;
  height: 100%;
  position: relative;
  margin: 0 auto;
}
.container {
  margin: 10px 0 30px 0;
  height: 100%;
  position: relative;
  background: #fff;
  border-radius: 10px;
  color: #000;
  min-height: 700px;
  .a-tip {
    height: 233px;
    width: 30px;
    position: absolute;
    margin: 0;
    z-index: 1;
    .link {
      display:inline-block;
      height: 110px;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      cursor: pointer;
      padding: 10px 0;
      padding-left: 7px;
      background: #fcc485;
      color: #b25d24;
    }
    .link:hover,
    .link.router-link-exact-active{
      background: #023b9d;
      color: #fff;
    }
  }
}

.img-small {
  width: 10px;
  height: 10px;
  margin-left: 8px;
  margin-right: 12px;
}
</style>
